import { STATIC_BASE_PATH as i } from "../../../constants.js";
const o = `${i}/home`, u = (a) => {
  const { language: t, getTranslation: e } = a;
  return [
    {
      image: `${o}/about-technology.webp`,
      description: e("about.menu.ai-technology-description"),
      title: e("about.menu.ai-technology"),
      path: `/${t}/about/ai-technology`
    },
    {
      image: `${o}/about-network.webp`,
      description: e("about.menu.legal-network-description"),
      title: e("about.menu.legal-network"),
      path: `/${t}/about/legal-network`
    },
    ...t === "en-au" ? [{
      image: `${o}/about-browse-lawyers.webp`,
      description: e("about.menu.browse-lawyers-description"),
      title: e("about.menu.browse-lawyers"),
      path: `/${t}/find`,
      isDefaultStyle: !0
    }] : [],
    {
      image: `${o}/about-company.webp`,
      description: e("about.menu.company-description"),
      title: e("about.menu.company"),
      path: `/${t}/about/company`
    },
    {
      image: `${o}/about-careers.webp`,
      description: e("about.menu.careers-description"),
      title: e("about.menu.careers"),
      path: `/${t}/about/careers`
    },
    {
      image: `${o}/about-sailing.webp`,
      description: e("about.menu.sailing-description"),
      title: e("about.menu.sailing"),
      path: `/${t}/about/sailing`
    }
  ];
};
export {
  u as getAboutLinks
};
